const doc = [({"installment":"Betaling in termijnen", "limited_subscription":"Beperkt abonnement", "one_time":"Eenmalig", "subscription":"Abonnement"})];
module.exports = doc.length <= 1 ? doc[0] : doc;